import { useState } from 'react';

interface OcrPage {
  page: number;
  text: string;
  confidence: number;
}

interface OcrTextViewerProps {
  pages: OcrPage[];
  highlightedPage?: number;
}

export function OcrTextViewer({ pages, highlightedPage }: OcrTextViewerProps) {
  const [currentPage, setCurrentPage] = useState(highlightedPage || 1);

  const currentPageData = pages.find(p => p.page === currentPage);

  if (!currentPageData) {
    return (
      <div className="bg-gray-50 border rounded p-4">
        <p className="text-gray-500">Aucun texte OCR disponible</p>
      </div>
    );
  }

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToNextPage = () => {
    if (currentPage < pages.length) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <div className="border rounded">
      {/* Header */}
      <div className="px-4 py-3 bg-gray-50 border-b flex items-center justify-between">
        <div className="flex items-center gap-4">
          <span className="font-semibold text-sm">📝 Texte OCR</span>
          <span className="text-sm text-gray-600">
            Confiance: {(currentPageData.confidence * 100).toFixed(1)}%
          </span>
        </div>

        <div className="flex items-center gap-2">
          <button
            onClick={goToPreviousPage}
            disabled={currentPage === 1}
            className="px-3 py-1 border rounded bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed text-sm"
          >
            ← Page
          </button>

          <span className="text-sm font-medium">
            Page {currentPage} / {pages.length}
          </span>

          <button
            onClick={goToNextPage}
            disabled={currentPage === pages.length}
            className="px-3 py-1 border rounded bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed text-sm"
          >
            Page →
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="p-4 bg-white">
        <pre className="whitespace-pre-wrap font-mono text-sm text-gray-800 max-h-96 overflow-y-auto">
          {currentPageData.text}
        </pre>
      </div>
    </div>
  );
}
